import { accent } from "../hooks/tokens.js";
import { ARTICLES, COURSES } from "../data.js";

const groupDefs = [
  { name: "Fondamentaux", ids: ["subnetting", "ospf-lsa"] },
  { name: "Routage", ids: ["bgp-attrs", "redistribution"] },
  { name: "Commutation", ids: ["vlan-trunk", "vxlan"] },
  { name: "Sécurité & accès", ids: ["ipsec"] },
  { name: "Moderne", ids: ["ansible"] },
];

// Accueil : notions en vedette, groupes thématiques, cartes de progression
// des parcours (v.openSearch et v.toolLinks viennent de searchView/navView).
export function buildHomeView(ctx) {
  const { patch, inputRef, go, goCourse, courseProgress } = ctx;
  return {
    hotTags: ["subnetting", "route-map", "OSPF LSA", "BGP", "802.1Q", "VXLAN", "IPsec"].map((t) => ({
      label: t,
      color: "oklch(0.42 0.015 60)", bg: "transparent", border: "oklch(0.92 0.008 85)",
      onClick: () => { patch({ searchOpen: true, query: t }); setTimeout(() => { if (inputRef.current) inputRef.current.focus(); }, 30); },
    })),
    groups: groupDefs.map((g) => ({
      name: g.name, color: "oklch(0.42 0.015 60)", soft: "transparent", line: "transparent",
      items: g.ids.map((id) => ({ label: ARTICLES.find((a) => a.id === id).title, onClick: () => go(id) })),
    })),
    tracks: COURSES.map((c, i) => {
      const p = courseProgress(c);
      return { name: c.label, pct: p.pct, next: "Prochain : " + (p.next || "quiz de validation"),
        color: i === 0 ? accent : "oklch(0.45 0.015 60)", soft: "oklch(0.94 0.006 85)",
        onClick: () => goCourse(c.id) };
    }),
  };
}
